import { Paper, Stack, TextField } from '@mui/material';
import { formatDate } from '../../../../utils/dateHelpers';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import { RootState } from '../../../../reducers';
import { setPropertiesOnSelectedCallItem } from '../../../../store/officeScheduler.slice';

const SchedulingEngagementInput: React.FC = () => {
    const dispatch = useAppDispatch();
    const { schedulingProvider, selectedCallItem } = useSelector((state: RootState) => state.officeSchedulerSlice);
    const status = useMemo(() => selectedCallItem?.CallStatus ?? '', [selectedCallItem]);
    const contactTime = useMemo(() => {
        if (selectedCallItem?.LastContact === null || selectedCallItem.LastContact === undefined) return '';
        return selectedCallItem.LastContact !== null ? formatDate(new Date(selectedCallItem.LastContact), 'MM/dd/yyyy h:mm aa') : null;
    }, [selectedCallItem]);

    return (
        <Stack spacing={1}>
            <span className="documentation-detail">{contactTime}</span>
            <span className="documentation-detail">Status: {status}</span>
            <span className="documentation-detail">{schedulingProvider.FullName ?? ''}</span>
            <Paper elevation={2} style={{ width: '100%' }}>
                <TextField
                    fullWidth
                    label="Call Documentation"
                    placeholder="Enter Comment..."
                    id="documentation-input"
                    multiline
                    rows={6}
                    inputProps={{
                        style: {
                            padding: '1em',
                        },
                    }}
                    value={selectedCallItem?.Note ?? ''}
                    onChange={(event) => dispatch(setPropertiesOnSelectedCallItem({ Note: event.target.value }))}
                />
            </Paper>
        </Stack>
    );
};

export default SchedulingEngagementInput;
